import { render, staticRenderFns } from "./zoneProperty.vue?vue&type=template&id=8768b250&scoped=true&"
import script from "./zoneProperty.vue?vue&type=script&lang=js&"
export * from "./zoneProperty.vue?vue&type=script&lang=js&"
import style0 from "./zoneProperty.vue?vue&type=style&index=0&id=8768b250&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8768b250",
  null
  
)

export default component.exports